import bossSCommon from '@/lib/bossSCommon'

/**
 * 企業情報プレビューPC/SP共通 mixin
 */
export default {
  mixins: [bossSCommon],
  data () {
    return {
      isLightPlan: false,
      companyInfo: {
        name: '',
        catchCopy: '',
        introText: '',
        introImage: {
          id: '',
          fn: '',
          kbn: ''
        },
        businessContent: '',
        established: '',
        capital: '',
        sale: '',
        employeeNumber: '',
        averageAge: '',
        midCareerPercentage: '',
        representative: '',
        representativeProfile: '',
        note: '',
        hp: '',
        companyImage1: {
          id: '',
          fn: '',
          kbn: ''
        },
        companyImage1Caption: '',
        companyImage2: {
          id: '',
          fn: '',
          kbn: ''
        },
        companyImage2Caption: '',
        companyImage3: {
          id: '',
          fn: '',
          kbn: ''
        },
        companyImage3Caption: ''
      },
      report: {
        name: '',
        body: ''
      },
      environment: {
        womanRate: null,
        officerRate: null,
        overtime: null,
        ptoRate: null,
        maternityRate: null,
        lengthService: null,
        isKurumin: false,
        isPlatinumKurumin: false,
        isNadeshiko: false,
        isEruboshi: false,
        womanAction: '',
        updateDate: ''
      },
      companySupplementInfo: {
        isVisibleInGoogle: false,
        name: '',
        nameKana: '',
        formalName: '',
        businessName: '',
        keywords: [],
        relationLinks: [],
        questions: []
      }
    }
  },
  computed: {
    id () {
      return Number(this.$route.params.id)
    }
  },
  created () {
    this.fetchCompany()
  },
  methods: {
    fetchCompany () {
      this.$http.secured.get(this.apiPathForCompany).then(response => {
        this.$set(this, 'isLightPlan', response.data.isLightPlan)
        this.$set(this, 'companyInfo', response.data.companyInfo)
        this.$set(this, 'report', response.data.report)
        this.$set(this, 'environment', response.data.environment)
        this.$set(this, 'companySupplementInfo', response.data.companySupplementInfo)
      })
    }
  }
}
